import React from 'react';
import { Button, Dialog, Classes } from '@blueprintjs/core';
import i18n from 'i18n';

export default class PopUp extends React.Component<any, any> {
  handleDialogOpened = () => {
    const dialogBody = document.querySelector(`.${Classes.DIALOG_BODY}`) as HTMLElement;
    if (dialogBody) {
      const firstInput = dialogBody.querySelector('input') as HTMLElement;
      if (firstInput) {
        firstInput.focus();
      }
    }
  };

  render() {
    const {
      title = i18n.t('common.dialog.title'),
      width = '300px',
      height = '100%',
      minWidth = '300px',
      maxWidth = '910px',
      overflow = 'none',
      onSubmit,
    } = this.props;
    return (
      <Dialog
        onClose={this.props.handleClose}
        onOpened={this.handleDialogOpened}
        autoFocus
        title={title}
        isOpen={this.props.isOpen}
        canEscapeKeyClose={false}
        canOutsideClickClose={false}
        style={{
          width, height, minWidth, maxWidth, overflow,
        }}
      >
        <div className={Classes.DIALOG_BODY}>
          {this.props.children}
        </div>
        <div className={Classes.DIALOG_FOOTER_ACTIONS} style={{ paddingRight: '20px' }}>
          <Button
            data-test="popup-button-cancel"
            className="actionButton"
            onClick={this.props.handleClose}
            intent="none"
            text={i18n.t('common.button.cancel')}
          />
          <Button
            data-test="popup-button-withlabel"
            className="actionButton"
            onClick={onSubmit}
            intent="primary"
            active
            text={i18n.t('common.button.save')}
          />
        </div>
      </Dialog>
    );
  }
}
